import React from 'react';
import { cx } from './clases';

interface Props {
  /** Si está elegido: se anuncia con `aria-pressed` y se pinta en negro. */
  activo: boolean;
  onClick: () => void;
  children: React.ReactNode;
  /** Se escribe «Todos · 7»: el número va tras un punto medio, en cifras tabulares. */
  contador?: number | null;
  disabled?: boolean;
  /** `compacto`: 32 px (dentro de un banner); por omisión 36, y 44 en teléfono. */
  tamano?: 'normal' | 'compacto';
  className?: string;
  'aria-label'?: string;
}

/**
 * Filtro de un solo toque («Todos · 7» / «Por resolver · 2»). Un botón real con
 * `aria-pressed` (SPEC §8.5): el lector de pantalla dice «presionado».
 */
export const Chip: React.FC<Props> = ({
  activo,
  onClick,
  children,
  contador,
  disabled,
  tamano = 'normal',
  className,
  'aria-label': ariaLabel,
}) => (
  <button
    type="button"
    aria-pressed={activo}
    aria-label={ariaLabel}
    onClick={onClick}
    disabled={disabled}
    className={cx(
      'metas-foco inline-flex items-center gap-1.5 whitespace-nowrap rounded-metas-pill border px-3.5 text-[13px] font-semibold disabled:cursor-not-allowed disabled:opacity-50',
      // 44 px también en una tableta táctil: `max-md` sólo miraba el ancho (auditoría del 22-oct-2026).
      tamano === 'compacto' ? 'h-8 [@media(pointer:coarse)]:h-metas-tactil' : 'h-9 max-md:h-metas-tactil [@media(pointer:coarse)]:h-metas-tactil',
      activo
        ? 'border-metas-texto bg-metas-texto text-white'
        : 'border-metas-borde-control bg-metas-panel text-metas-texto-3 hover:bg-metas-cabecera',
      className,
    )}
  >
    {children}
    {contador !== undefined && contador !== null && <span className="num">· {contador}</span>}
  </button>
);

export default Chip;
